import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addHighlightToCurrentDiscussion, getPreviouslyAdded } from './slices/classroomSessionSlice';
import { YambaDispatch } from './store';
import { getUserType } from './slices/userSlice';

type AddHighlightToCurrentDiscussionProps = {
  comment: string,
  annotationText: string,
  timestamp: string,
};

const AddHighlightToCurrentDiscussion = ({
  comment,
  annotationText,
  timestamp
}: AddHighlightToCurrentDiscussionProps) => {
  const dispatch: YambaDispatch = useDispatch();
  const previouslyAdded = useSelector(getPreviouslyAdded(timestamp));
  const userType = useSelector(getUserType);

  const handleOnClick = () => {
    dispatch(addHighlightToCurrentDiscussion({
      comment,
      annotationText,
      timestamp,
      userType
    }));
  };

  return (
    <div className="u-flex u-flexJustifyEnd">
      <button
        type="button"
        className="btn btn-primary-outline right-buffer-lg bottom-buffer-lg"
        onClick={handleOnClick}
      >
        {previouslyAdded ? 'Discuss again' : 'Add to discussion'}
      </button>
    </div>
  );
};

export default AddHighlightToCurrentDiscussion;
